import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import parser from "html-react-parser";
import jsonLogic from "json-logic-js";
import React, { useEffect, useState } from "react";
import { decryptHTML, appendUtmQueryToTargetUrl, getRedirectMode } from "../../services/utils";
import { defaultHtml } from "../constants";
import axios from "axios";
import CryptoJS from "crypto-js";
import { PopUpWidgetContainer, Image } from "../../styles/widget_styles";
import '@/styles/target-styles.css'
import { Data } from "../../services/type";

let sendAdImp = true;

const PopUpWidget: React.FC<any> = (props) => {
  const { popup_target_config } = props;
  const daystoshow = popup_target_config.daysToShow
    ? popup_target_config.daysToShow
    : '["0", "1", "2", "3", "4", "5", "6"]';

  const [popupIsVisible, setPopupIsVisible] = useState(false);
  const [popupData, setPopupData] = useState({
    imageUrl: "",
    targetUrl: "",
    title: "",
    description: "",
    uploadHtml: false,
    htmlContent: "",
  });
  const [isShowErrorMsg, setIsShowErrorMsg] = useState<boolean>(false);
  const [isDesktopView, setIsDesktopView] = useState<boolean>(
    window.innerWidth > 500
  );
  const delay = popup_target_config.timeDelay ? +popup_target_config.timeDelay + 1 : 1;


  // Code to  add the UTM query parameter on target URL
  const browser_query = window.location.search;
  const utmRegex = /(?:\?|&)(utm_[^=]+|utmMDMContactID|formID|formName|reportSuite|formType|utmPromoCode)=([^\s&]+)/g;

  useEffect(() => {
    const rule_list = popup_target_config?.rule;
    if (popup_target_config?.utmparam === "yes") {
      appendUtmQueryToTargetUrl(popup_target_config, browser_query.match(utmRegex))

    }
    if (Array.isArray(rule_list) && rule_list.length > 0) {
      rule_list.forEach((ele: any) => {
        if (ele?.utmparam === true && !ele?.targetURL?.includes(browser_query)) {
          // browser_qurey.match(Regex) will retur the list of  query parameter which needs to append/update in target url
          appendUtmQueryToTargetUrl(ele, browser_query.match(utmRegex));
        }
      })
    }
  }, [])

  function setItemWithExpiry(key: any, value: any, totalSeconds: any) {
    const now = Date.now();
    const item = {
      value,
      storedAt: now,
      expiresAt: now + totalSeconds * 1000,
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  function getItemWithExpiry(key: any) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;

    const item = JSON.parse(itemStr);
    if (Date.now() > item.expiresAt) {
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  }

  useEffect(() => {
    if (popup_target_config.adminCenter === "yes") {
      getSegments();
    } else {
      new Promise((resolve) => setTimeout(resolve, delay * 1000)).then(
        async () => {
          if (
            !(
              getItemWithExpiry("_iiris_popup_ad") ||
              getItemWithExpiry(popup_target_config.cookieName)
            ) &&
            JSON.parse(daystoshow).includes(new Date().getDay().toString())
          ) {
            await getSegments();
          }
        }
      );
    }
  }, [isDesktopView]);

  useEffect(() => {
    function handleResize() {
      setIsDesktopView(window.innerWidth > 500);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  });

  const closePopUp = (e: any) => {
    // Stop event propagation.
    e.stopPropagation();
    e.preventDefault();
    const date = new Date();
    setPopupIsVisible(false);
    if (popup_target_config.cookieChoice === "once") {
      const cookieName =
        popup_target_config.adminCenter === "yes" ? popup_target_config.cookieName : "_iiris_popup_ad";

      setItemWithExpiry(cookieName, { storedAt: date.getTime() }, 86400);        
    }
  };

  const addClickImpression = (sourceUrl: string) => {
    let redirectUrl;
    try {
      redirectUrl = new URL(sourceUrl);
      redirectUrl.searchParams.append("iiris-ref", "target");
    } catch (e) {
      redirectUrl = sourceUrl + "?iiris-ref=target";
    }
    // Ad Impression Event OnClick
    popup_adImpression("click", redirectUrl.toString());
  };

  const popup_adImpression = (zone: string, redirectUrl?: string) => {
    if (window.IIRISTracker && window.IIRISTracker.trackImpression) {
      const impressionId = popup_target_config.imageUrl || window.location.href;
      const bannerId = popup_target_config.bannerId;
      const campaignId = popup_target_config.campaignId;
      const advertiserId = popup_target_config.advertiserId;

      let newImpressionId;
      try {
        newImpressionId = new URL(impressionId);
        newImpressionId.searchParams.append("widgetId", popup_target_config.id);
        newImpressionId.searchParams.append(
          "rule",
          popup_target_config.ruleNo ? popup_target_config.ruleNo : 0
        );
        newImpressionId.searchParams.append("iiris-ref", "target");
      } catch {
        newImpressionId = impressionId.replaceAll(" ");
        newImpressionId += `?widgetId=${popup_target_config.id}&rule=${popup_target_config.ruleNo ? popup_target_config.ruleNo : 0
          }&iiris-ref=target`;
      }

      const data: Data = {
        impressionId: newImpressionId.toString(),
        bannerId: bannerId,
        campaignId: campaignId,
        advertiserId: advertiserId,
        zoneId: zone,
      };

      if (zone === "click") {
        data.targetUrl = popupData.targetUrl || popupData.imageUrl;
        const ctrEvt = new CustomEvent("recommendCTREvent", {
          detail: { target_url: redirectUrl },
        });
        window.dispatchEvent(ctrEvt);
      } else if (zone === "viewport") {
        const viewportEvt = new CustomEvent("iiris_recommendViewportEvent", {
          detail: { impressionId: newImpressionId },
        });
        window.dispatchEvent(viewportEvt);
      }

      window.IIRISTracker.trackImpression(data);
    }
  };

  const setDefaultRule = () => {
    let image, width, height, selectedWidth;
    if (popup_target_config.adminCenter) {
      image = popup_target_config.mobilePreview
        ? popup_target_config.mobileViewImageUrl || popup_target_config.imageUrl
        : popup_target_config.imageUrl;
    } else {
      image = isDesktopView
        ? popup_target_config.imageUrl
        : popup_target_config.mobileViewImageUrl || popup_target_config.imageUrl;
    }
    setPopupData({
      imageUrl: image,
      targetUrl: popup_target_config.targetUrl,
      title: popup_target_config.popupTitle,
      description: popup_target_config.description,
      uploadHtml: popup_target_config.uploadHtml,
      htmlContent: decryptHTML(popup_target_config.htmlContent),
    });
    if (popup_target_config.uploadHtml) {
      popup_target_config.imageUrl = popup_target_config.htmlContent;
    }
    checkCampaignValidity();
  };

  const checkCampaignValidity = () => {
    if (!popup_target_config.adminCenter) {
      const now = new Date();
      const _endDate = new Date(popup_target_config.endDate);
      const now_utc = Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate(),
        now.getUTCHours(),
        now.getUTCMinutes(),
        0
      );
      const endDate_utc = Date.UTC(
        _endDate.getFullYear(),
        _endDate.getMonth(),
        _endDate.getDate(),
        _endDate.getHours(),
        _endDate.getMinutes(),
        0
      );
      if (popup_target_config.endDate && now_utc > endDate_utc) {
        setPopupIsVisible(false);
      } else {
        setPopupIsVisible(true);
        //Tracking Viewport event for ad impression
        if (sendAdImp) {
          // Ad Impression event when recommendation is seen by the user
          sendAdImp = false;
          popup_adImpression("viewport");
        }
      }
    } else {
      setPopupIsVisible(true);
      //Tracking Viewport event for ad impression
      if (sendAdImp) {
        // Ad Impression event when recommendation is seen by the user
        sendAdImp = false;
        popup_adImpression("viewport");
      }
    }
  };

  const getSegments = async () => {
    let rules: any[], token;
    const decryptKey = "secret_key_iiris_recommend";
    if (popup_target_config.configId) {
      rules = popup_target_config.rule;
      token = popup_target_config.token;
    } else {
      const _ciphertext = CryptoJS.AES.decrypt(
        popup_target_config.rule.toString(),
        decryptKey
      );
      const c_text = _ciphertext.toString(CryptoJS.enc.Utf8);
      const _rules = JSON.parse(c_text);
      rules = _rules.config;
      token = _rules.token;
    }

    if (!popup_target_config.userid) {
      while (window.IIRISTracker?.getDUId() == undefined) {
        await new Promise((r) => setTimeout(r, 5)); //wait for tracker to load
      }
    }

    for (const rule of rules) {
      try {
        let segmentApiCall;
        if (JSON.stringify(rule).includes("batch")) {
          segmentApiCall = await axios.get(
            `${import.meta.env.VITE_SEGMENT_API_BASE_URL}/public/treasuredata?token=${token}&first_party_tracking_id=${popup_target_config.userid || window.IIRISTracker?.getDUId()}`
          );
        } else {
          segmentApiCall = await axios.get(
            `${import.meta.env.VITE_SEGMENT_API_BASE_URL}/public/treasuredata?token=${token}&td_client_id=${popup_target_config.userid || window.IIRISTracker?.getDUId()}`
          );
        }
        const segmentResponse = segmentApiCall?.data;

        if (segmentResponse && segmentResponse[0] && rules.length) {
          const computeRules: boolean[] = [];
          let ruleConfig: any = null;
          segmentResponse[0].values.forEach((value: any) => {
            let result: any;
            if (JSON.stringify(rule).includes("batch")) {
              result = {
                segmentId: [
                  {
                    batch: value,
                  },
                ],
              };
            } else {
              result = {
                segmentId: [
                  {
                    realTime: value,
                  },
                ],
              };
            }
            let output = rules.find((e) => jsonLogic.apply(e.tree, result));
            if (!output) {
              const result1 = { segmentId: value };
              output = rules.find((e) => jsonLogic.apply(e.tree, result1));
            }
            if (output) {
              computeRules.push(true);
              if (ruleConfig === null) ruleConfig = output;
            } else if (!output && !JSON.stringify(rule).includes(value)) {
              computeRules.push(true);
            } else computeRules.push(false);
          });
          const valid = computeRules.every((item) => item);
          if (valid && ruleConfig !== null) {
            rules.forEach((rule, index) => {
              if (rule.id === ruleConfig.id) {
                popup_target_config.ruleNo = index + 1;
              }
            });
            let image;
            if (popup_target_config.adminCenter) {
              image = popup_target_config.mobilePreview
                ? ruleConfig.mobileViewImageUrl || ruleConfig.imageUrl
                : ruleConfig.imageUrl;
            } else {
              image = isDesktopView
                ? ruleConfig.imageUrl
                : ruleConfig.mobileViewImageUrl || ruleConfig.imageUrl;
            }
            setPopupData({
              imageUrl: image,
              targetUrl: ruleConfig.targetUrl,
              title: ruleConfig.title,
              description: ruleConfig.description,
              uploadHtml: ruleConfig.uploadhtml,
              htmlContent: decryptHTML(ruleConfig.htmlCode),
            });
            popup_target_config.imageUrl = ruleConfig.uploadHtml
              ? ruleConfig.htmlContent
              : image;
            checkCampaignValidity();
            return true;
          }
        }
      } catch (e) {
        console.log(e);
      }
    }
    if (popup_target_config.defaultRuleEnabled && popup_target_config.defaultRuleEnabled !== "no") {
      setDefaultRule();
    } else {
      setIsShowErrorMsg(true);
    }
  };

  const visualMode: 'popup' | 'sticky' = !isDesktopView || popup_target_config.widgetposition === 'center' ? 'popup' : 'sticky';

  return popupIsVisible && (popupData.imageUrl || popupData.htmlContent) ? (
    <div className={`iiris-${visualMode}-overlay`} onClick={closePopUp}>
      <PopUpWidgetContainer
        className={popup_target_config.animate || ""}
        variant={visualMode}
        widgetposition={popup_target_config.widgetposition}
        border={popup_target_config.showborder}
        bordercolor={popup_target_config.bordercolor}
        bottommargin={popup_target_config.bottomMargin}
        leftmargin={popup_target_config.leftMargin}
        rightmargin={popup_target_config.rightMargin}
        buttontopmargin={popup_target_config.buttonTopMargin}
        buttonrightmargin={popup_target_config.buttonRightMargin}
        showbuttonborder={popup_target_config.showbuttonBorder}
        bordersize={popup_target_config.borderSize}
        buttonsize={popup_target_config.buttonSize}
        buttoncolor={popup_target_config.buttonColor}
        buttonbordercolor={popup_target_config.buttonBorderColor}
        buttonfill={popup_target_config.buttonFill}
        width={popup_target_config.width}
        height={popup_target_config.height}
        id={popup_target_config?.configId || ""}
        onMouseEnter={() => popup_adImpression("onMouseEnter")}
      >
        {popupData.uploadHtml ? (
          <div className="html-body">
            <div className="iiris-popup-close-btn">
              <FontAwesomeIcon data-testid="popup-close-btn" className="close-popup" icon={faClose} onClick={closePopUp} />
            </div>
            {parser(popupData.htmlContent || defaultHtml)}
          </div>
        ) : (
          <div className="iiris-popup-body">
            <div className="iiris-popup-close-btn">
              <FontAwesomeIcon className="close-popup" icon={faClose} onClick={closePopUp} />
            </div>
            <a
              href={popupData.targetUrl}
              target={getRedirectMode(popup_target_config)}
              onClick={(e) => {
                e.stopPropagation();
                addClickImpression(popupData.targetUrl);
                setTimeout(() => closePopUp(e), 0);
              }}
            >
              <Image src={popupData.imageUrl} alt="ad-image" />
            </a>
          </div>
        )}
      </PopUpWidgetContainer>
    </div>
  ) : isShowErrorMsg && popupData.imageUrl === "" && popup_target_config.adminCenter === "yes" ? (
    <div className="flex align-items-center justify-content-center">
      <div>
        <h3 className="no-image flex justify-content-center">No Popup</h3>
        <div>
          <h6 className="flex justify-content-center">
            User ID [{popup_target_config.userid}] doesn’t match any targeting rule.
          </h6>
        </div>
      </div>
    </div>
  ) : null;
};

export { PopUpWidget };